<template>
  <div class="tags-page">
    <div class="page-decoration"></div>
    <h2 class="page-title">标签分类</h2>

    <!-- 标签筛选 -->
    <div class="tags-cloud" v-if="tags.length">
      <div
        :class="['tag-item', { active: currentTag === '' }]"
        :style="getAllTagStyle"
        @click="filterByTag('')"
      >
        全部 <span class="tag-count">({{ totalArticles }})</span>
      </div>
      <div
        :class="['tag-item', { active: currentTag === tag.slug }]"
        v-for="tag in tags"
        :key="tag.id"
        :style="getTagStyle(tag)"
        @click="filterByTag(tag.slug)"
      >
        {{ tag.name }} <span class="tag-count">({{ tag.article_count }})</span>
      </div>
    </div>
    <el-empty v-else description="暂无标签" />

    <!-- 文章列表 -->
    <div class="tags-articles">
      <h3 class="filter-title" v-if="currentTag">
        <span class="filter-tag-pill">{{ currentTagInfo.name }}</span>
        下的文章
      </h3>
      <h3 class="filter-title" v-else>全部文章</h3>
      <div v-loading="loading">
        <ArticleCard v-for="article in articles" :key="article.id" :article="article" />
        <el-empty v-if="!articles.length && !loading" description="暂无文章" />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from '../../components/ArticleCard.vue'
import { frontApi } from '../../utils/api'

export default {
  name: 'Tags',
  components: { ArticleCard },
  data() {
    return { tags: [], currentTag: '', articles: [], loading: false, totalArticles: 0 }
  },
  computed: {
    currentTagInfo() { return this.tags.find(t => t.slug === this.currentTag) || {} },
    getAllTagStyle() {
      const isActive = this.currentTag === ''
      return {
        color: isActive ? '#fff' : 'var(--blog-text-2)',
        backgroundColor: isActive ? 'var(--blog-accent)' : 'transparent',
        borderColor: isActive ? 'var(--blog-accent)' : 'var(--blog-border)',
        fontSize: '1.05rem'
      }
    }
  },
  created() {
    this.tags = this.$store.state.tags
    if (!this.tags.length) this.loadTags()
    const tagQuery = this.$route.query.tag
    if (tagQuery) this.currentTag = tagQuery
    this.loadArticles()
  },
  methods: {
    async loadTags() {
      try { const res = await frontApi.getTags(); this.tags = res.tags || [] } catch (e) { console.error(e) }
    },
    async loadArticles() {
      this.loading = true
      try {
        const params = this.currentTag ? { tag: this.currentTag, per_page: 100 } : { per_page: 100 }
        const res = await frontApi.getArticles(params)
        this.articles = res.articles || []
        this.totalArticles = res.pagination ? res.pagination.total : this.articles.length
      } catch (e) { console.error(e) }
      this.loading = false
    },
    filterByTag(slug) {
      this.currentTag = slug
      this.loadArticles()
      if (slug) { this.$router.replace({ path: '/tags', query: { tag: slug } }) }
      else { this.$router.replace({ path: '/tags' }) }
    },
    getTagStyle(tag) {
      const isActive = this.currentTag === tag.slug
      const count = tag.article_count || 0
      const size = Math.min(1.2, 0.95 + count * 0.02)
      return {
        color: isActive ? '#fff' : 'var(--blog-text-2)',
        backgroundColor: isActive ? 'var(--blog-accent)' : 'transparent',
        borderColor: isActive ? 'var(--blog-accent)' : 'var(--blog-border)',
        fontSize: `${size}rem`
      }
    },
    softenColor(hex, alpha) {
      if (!hex) return alpha !== undefined ? 'rgba(196, 122, 58, 0.08)' : '#c47a3a'
      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)
      if (alpha !== undefined) return `rgba(${r}, ${g}, ${b}, ${alpha})`
      const blend = (c) => Math.round(c * 0.7 + 80 * 0.3)
      return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`
    }
  }
}
</script>

<style scoped>
.tags-page { max-width: 56rem; margin: 0 auto; padding: 2.5rem 1.5rem 5rem; }
.page-decoration { width: 2.5rem; height: 0.25rem; background: var(--blog-accent); border-radius: 0.125rem; margin-bottom: 1rem; }
.page-title { font-family: var(--font-display); font-size: 2rem; font-weight: 700; color: var(--blog-text); margin-bottom: 1.5rem; letter-spacing: -0.02em; }

.tags-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1.25rem;
  background: var(--blog-bg-elevated);
  border: 1px solid var(--blog-border);
  border-radius: 0.75rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-sm);
}

.tag-item {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.9rem;
  border-radius: 2rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
  font-weight: 500;
  user-select: none;
}
.tag-item:hover { transform: translateY(-2px); box-shadow: var(--shadow-sm); }
.tag-item.active { color: #fff !important; box-shadow: var(--shadow-sm); }

.tag-count { font-size: 0.75rem; opacity: 0.75; margin-left: 0.25rem; font-weight: 400; }

.tags-articles { max-width: 42rem; margin: 0 auto; }
.filter-title { font-size: 1.1rem; font-weight: 600; color: var(--blog-text); margin-bottom: 1.25rem; display: flex; align-items: center; gap: 0.5rem; }
.filter-title .el-tag { border: none; font-family: var(--font-mono); text-transform: uppercase; letter-spacing: 0.04em; }
.filter-tag-pill { display: inline-flex; align-items: center; padding: 0.2rem 0.7rem; border-radius: 1rem; background: var(--blog-accent); color: #fff; font-size: 0.85rem; font-weight: 500; }
</style>
